<app-header (closeEvent)="onCloseEvent($event)" [currentTab]="2"></app-header>
<div class="voxel-container-md container-padding">

    <h3 class="title" voxelHeaderTitle>{{this.CONTENT_BOUNDS?.title}}</h3>

    <div class="container-data">
        <app-form-solicitation-search (findRequest)="findRequest($event)" [formGroup]="searchForm">
        </app-form-solicitation-search>
    </div>

</div>